<!--课程选择-->
<template>
  <div
    :class="['courseSelect-index', { notShow: productSpecJson && productSpecJson.length === 0 }]"
  >
    <div class="courseSelect" v-for="(item, n) in productSpecJson" :key="n">
      <h3 class="subheading">{{ item.name }}</h3>
      <div class="courseSelectTabs">
        <p
          v-for="(list, index) in item.options"
          @click="chooseSkuInfo(list.name, n, $event, index, list.isShow)"
          :class="{ tabItem: true, tabSelected: subIndex[n] == index, noneActive: !list.isShow, hidden: list.isHidden }"
          :key="index"
        >
          <span>{{ list.name }}</span>
          <img v-if="subIndex[n] == index" :src="checkIcon" alt="checkIcon" />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import checkIcon from '../../assets/img/components/courseDetail/checkIcon.png';

export default {
  props: [],
  data() {
    return {
      checkIcon,
      selectedIndex: 0,
      productSpecJson: [], // 展示在页面的sku规格
      iconChecked: checkIcon, // sku选中状态icon
      selectArr: [], // 选中的值
      shopItemInfo: {}, // 存放要和选中的值进行匹配的数据
      subIndex: [], // 是否选中
      selectSku: {}, // 选中的sku信息
      someOne: null, // 可用的一条sku，用于展示默认的sku
    };
  },
  computed: {
    ...mapState(['courseBaseData', 'buyStatus', 'groupBuyDetailVuex']),
  },

  watch: {
    selectSku(sku) {
      this.sendParentSkuId(sku);
    },
    courseBaseData: {
      handler(v) {
        if (v) {
          // 购课后更新sku
          const { productSkuRespVOList } = this.courseBaseData;
          if (productSkuRespVOList) {
            this.setDefault(productSkuRespVOList);
          }
          this.productSpecJson = [];
          this.shopItemInfo = {};
          this.someOne = null;
          // Object.assign(this.$data, this.$options.data());
          this.modifySkuRespVOList();
        }
      },
      deep: true,
    },
    buyStatus: {
      handler(newVal, oldVal) {
        // console.log(newVal, oldVal, 6666777);
        if (newVal.length === oldVal.length) return;
        Object.assign(this.$data, this.$options.data());
        this.modifySkuRespVOList();
      },
    },
  },

  mounted() {
    this.checkItem();
  },

  methods: {
    changeTab(index) {
      this.selectedIndex = index;
    },
    // 选中sku属性
    chooseSkuInfo(item, n, event, index, canClick) {
      if (!canClick) {
        return false;
      }
      if (this.selectArr[n] !== item) {
        [this.selectArr[n], this.subIndex[n]] = [item, index];
      } else {
        this.selectSku = {};
        [this.selectArr[n], this.subIndex[n]] = ['', '-1'];
      }
      this.pubChangeSku();
      this.checkItem();
      console.log(this.selectArr, '选择');
      return true;
    },
    checkItem() {
      const self = this;
      const result = this.selectArr; // 定义数组储存被选中的值
      for (let i = 0; i < this.productSpecJson.length; i += 1) {
        result[i] = self.selectArr[i] ? self.selectArr[i] : '';
      }
      if (this.productSpecJson) {
        this.productSpecJson.forEach((element, i) => {
          const last = result[i];
          element.options.forEach(k => {
            result[i] = k.name;
            Object.assign(k, { isShow: self.someOne ? self.isMay(result) : false }); // isShow来判断是否可以选择})
            // k.isShow = this.someOne ? this.isMay(result) : false; // isShow来判断是否可以选择
          });
          result[i] = last; // 还原，目的是记录点下去那个值
        });
      }
      if (this.shopItemInfo[result]) {
        this.selectSku = this.shopItemInfo[result];
      }
      self.$forceUpdate(); // 重绘
    },
    pubChangeSku() {
      setTimeout(() => {
        console.log(this.selectArr, this.selectArr.join('+'), 'sku信息');
        PubSub.publish('course_detail_change_classtime', this.selectArr.join('+'));
      }, 0);
    },
    // 能否被选中
    isMay(result) {
      for (let k = 0; k < result.length; k += 1) {
        if (result[k] === '') {
          return true;
        }
      }
      // 校验list中是否有此条sku
      if (result && !this.shopItemInfo[result]) {
        return false;
      }
      // 库存校验
      return !(
        this.shopItemInfo[result].isSetStock === 1 && this.shopItemInfo[result].availableStock === 0
      );
    },
    handeAvailableStockObj(item) {
      const list = JSON.parse(item.specJson).map(child => child.value);
      list.forEach(spec => {
        if (!this.availableStockObj[spec]) {
          this.availableStockObj[spec] = 1;
        } else {
          this.availableStockObj[spec] += 1;
        }
      });
    },
    // 修改数据结构,将选中的值作为key，以方便和选中之后的值进行匹配
    modifySkuRespVOList() {
      const { productSkuRespVOList, productSpecJson } = this.courseBaseData;
      if (!productSpecJson && !productSkuRespVOList) return;
      if (!productSpecJson) {
        // 无sku
        this.$store.dispatch('saveProductSku', productSkuRespVOList[0]);
        return;
      }
      this.availableStockObj = {}; // 记录每个规格的库存映射
      productSkuRespVOList.forEach(item => {
        if (this.$route.path === '/groupProgress') {
          if (item.groupActivity) {
            this.handeAvailableStockObj(item);
            this.shopItemInfo[String(JSON.parse(item.specJson).map(child => child.value))] = item;
          }
        } else {
          this.handeAvailableStockObj(item);
          this.shopItemInfo[String(JSON.parse(item.specJson).map(child => child.value))] = item;
        }
      });

      JSON.parse(productSpecJson).forEach(item => {
        Object.assign(item, {
          options: item.options.map(element => ({
            name: element,
            isHidden: !this.availableStockObj[element],
          })),
        });
        this.productSpecJson.push(item);
      });
      const that = this;
      this.$nextTick(() => {
        that.allSkuBuyStatus(this.productSpecJson);
      });
      this.setDefault(productSkuRespVOList);
      this.checkItem();
    },
    // 判断当前展示的sku是不是都置灰了，如果都置灰了，下方的购买按钮需要更新成不可购买：已售罄
    allSkuBuyStatus(data) {
      console.log('data++++++++', data);
      const allSkuShowed = []; // 所有展示的sku
      data.forEach(item => {
        const itemSkuList = item.options.filter(item2 => !item2.isHidden)?.length
          ? item.options.filter(item2 => !item2.isHidden)
          : [];
        if (itemSkuList.length) {
          allSkuShowed.push(...itemSkuList);
        }
      });
      if (!allSkuShowed?.length) return;
      console.log('allSkuShowed++', allSkuShowed);
      if (allSkuShowed.every(item => !item.isShow)) {
        PubSub.publish('editBuybtnStatus', { bgColor: 'sellOut', btnTxt: '已售罄', state: 4 });
      }
    },
    // 默认一个可用的sku
    setDefault(productSkuRespVOList) {
      const defautIdx = [];
      const defautName = [];
      if (this.groupBuyDetailVuex && this.$route.path === '/groupProgress') {
        // 拼团订单页的选中sku回显
        this.someOne = productSkuRespVOList.find(
          item =>
            item.productSkuId === this.groupBuyDetailVuex.productSkuId && item.isDefault === 0,
        );
      } else if (this.buyStatus.length) {
        // 已购的课程，选中用户购买时的sku
        this.someOne = productSkuRespVOList.find(
          item => item.productSkuId === this.buyStatus[0].skuId && item.isDefault === 0,
        );
      } else {
        this.someOne = productSkuRespVOList.find(
          item => (item.isSetStock === 1 && item.availableStock > 0) || item.isSetStock === 0,
        );
      }
      // this.someOne = productSkuRespVOList
      //   ? productSkuRespVOList.find((item) => (item.isSetStock === 1 && item.availableStock > 0) || item.isSetStock === 0)
      //   : null;
      if (!this.someOne) return;
      this.productSpecJson.forEach(item => {
        item.options.forEach((list, i) => {
          JSON.parse(this.someOne.specJson).forEach(m => {
            if (list.name === m.value) {
              defautName.push(list.name);
              defautIdx.push(i);
            }
          });
        });
      });
      this.subIndex = defautIdx;
      this.selectArr = defautName;
      this.pubChangeSku();
      this.sendParentSkuId(this.someOne);
    },
    // 将选中的sku保存到vuex 中
    sendParentSkuId(sku) {
      if (!sku.productSkuId) return;
      this.$store.dispatch('saveProductSku', sku);
    },
  },
};
</script>

<style lang="scss" scoped>
.courseSelect-index {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 22px;
  overflow: hidden;
  background: white;
  border-radius: 14px;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03);
}

.notShow {
  margin: 0 !important;
}
.courseSelect {
  display: flex;
  width: 100%;
  min-height: 130px;
  // margin: 22px 0;
  padding: 16px 36px 0;
  background: #fff;
  // border-radius: 14px;
  // box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03);

  &:first-child {
    padding-top: 26px;
  }
  &:last-child {
    padding-bottom: 26px;
  }

  .subheading {
    flex-shrink: 0;
    min-width: 60px;
    margin-right: 19px;
    padding-top: 26px;
    color: #333;
    font-weight: bold;
    font-size: 25px;
    line-height: 30px;
  }
  .courseSelectTabs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 4px;

    p {
      position: relative;
      box-sizing: border-box;
      min-width: 173px;
      margin: 10px;
      padding: 12px 12px 12px 12px;
      color: #787878;
      font-size: 22px;
      line-height: 30px;
      text-align: center;
      background: #fff;
      border: 1.1px solid #e8e8e8;
      border-radius: 4px;

      img {
        position: absolute;
        right: 0;
        bottom: 0;
        display: none;
        width: 30px;
        height: auto;
      }
    }

    /* p:nth-child(3n) {
      margin-right: 0;
    }

    p:nth-child(n + 4) {
      margin-top: 20px;
    } */

    .tabSelected {
      box-sizing: border-box;
      color: #ff6c02;
      background: #fff5ed;
      border: 2px solid #ff6c02;
      border-radius: 4px;
      pointer-events: none;
      img {
        display: block;
      }
    }
    .hidden {
      display: none;
    }
    .noneActive {
      color: #cfcfcf;
      background: #f5f5f5;
      border: 2px solid #f5f5f5;
      border-radius: 4px;

      img {
        display: none;
      }
    }
  }
}
</style>
